import { Icon, IconProps } from "@chakra-ui/react";

const streak = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 23 30" {...props}>
      <path
        d="M14.4914 0C11.1764 9.93083 19.9172 10.0017 22.2689 16.1217C23.8555 19.9183 22.7789 24.2817 19.8322 27.0158C17.1547 29.4667 13.4289 30.1042 9.98637 29.665C7.57803 29.3533 0.877201 26.9167 0.338867 18.9833C0.338867 11.8717 4.16387 9.52 4.16387 9.52C4.16387 9.52 1.0897 16.9008 8.1022 19.8475C3.14387 10.1717 8.15887 2.8475 14.4914 0Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default streak;
